// extracted by mini-css-extract-plugin
module.exports = {"grid":"editor_grid__3zn8n","actionbarWrapper":"editor_actionbarWrapper__1erCh","contentWrapper":"editor_contentWrapper__3pxBl"};